import axios from "axios";


const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || '',
    // A sessão passou a viajar num cookie httpOnly emitido pelo backend
    // (partilhado entre subdomínios via `Domain=.<dominio-raiz>`) em vez de
    // um token gerido pelo frontend — sem isto o browser não envia nem
    // aceita esse cookie em pedidos cross-origin (API noutro subdomínio).
    withCredentials: true,
})

const apiUri = api.getUri();

export { api, apiUri };
